import { apiFetch } from './api';

export interface ApiKeySummary {
  id: string;
  name: string | null;
  key_prefix: string;
  last_used_at: number | null;
  created_at: number;
  revoked_at: number | null;
}

export interface CreatedApiKey {
  id: string;
  key: string;
  key_prefix: string;
  name: string | null;
  created_at: number;
}

export async function listApiKeys(): Promise<{ keys: ApiKeySummary[]; limit: number }> {
  return apiFetch<{ keys: ApiKeySummary[]; limit: number }>('/api/keys');
}

export async function createApiKey(name?: string): Promise<CreatedApiKey> {
  return apiFetch<CreatedApiKey>('/api/keys', {
    method: 'POST',
    json: { name: name?.trim() || undefined },
  });
}

export async function revokeApiKey(id: string): Promise<void> {
  await apiFetch<{ ok: true }>(`/api/keys/${id}`, { method: 'DELETE' });
}
